/* eslint-disable @typescript-eslint/no-unused-vars */
import { NumericalColumn, StringColumn, DatetimeColumn } from 'baseui/data-table';
import { EMPTY_NUMBER, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	dt: 'dt',
	zupeeUserId: 'zupeeuserid',
	name: 'name',
	grossDepositAmount: 'gross_deposit_amount',
	grossWithdrawalAmount: 'gross_withdrawal_amount',
	cashGameGmv: 'cash_game_gmv',
	winnings: 'winnings',
	tdsCashback: 'tds_cashback',
	defAmount: 'def_amount',
	lastCustomState: 'last_custom_state',
	lastCustomCity: 'last_custom_city',
	signupState: 'signup_state',
	last3mGrossDepositAmount: 'last_3m_gross_deposit_amount',
	last3mDepositCount: 'last_3m_deposit_count',
	last3mWithdrawalAmount: 'last_3m_withdrawal_amount',
	netLossOnDeposit: 'net_loss_on_deposit',
	signupCity: 'signup_city'
};

export const columnConfigs = [
	StringColumn({
		title: 'Date',
		mapDataToValue: (data: any) => data[COL_NAMES.dt] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Zupee UID',
		mapDataToValue: (data: any) => data[COL_NAMES.zupeeUserId] || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Name',
		mapDataToValue: (data: any) => data[COL_NAMES.name] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Gross Deposit Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.grossDepositAmount] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Gross Withdrawal Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.grossWithdrawalAmount] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Cash Game GMV',
		mapDataToValue: (data: any) => data[COL_NAMES.cashGameGmv] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Winnings',
		mapDataToValue: (data: any) => data[COL_NAMES.winnings] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'TDS Cashback',
		mapDataToValue: (data: any) => data[COL_NAMES.tdsCashback] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Def Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.defAmount] || EMPTY_NUMBER
	}),
	StringColumn({
		title: 'Last Custom State',
		mapDataToValue: (data: any) => data[COL_NAMES.lastCustomState] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Last Custom City',
		mapDataToValue: (data: any) => data[COL_NAMES.lastCustomCity] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Signup State',
		mapDataToValue: (data: any) => data[COL_NAMES.signupState] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Signup City',
		mapDataToValue: (data: any) => data[COL_NAMES.signupCity] || EMPTY_STRING
	}),
	NumericalColumn({
		title: 'Last 3M Gross Deposit Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.last3mGrossDepositAmount] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Last 3M Deposit Count',
		mapDataToValue: (data: any) => data[COL_NAMES.last3mDepositCount] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Last 3M Withdrawal Amount',
		mapDataToValue: (data: any) => data[COL_NAMES.last3mWithdrawalAmount] || EMPTY_NUMBER
	}),
	NumericalColumn({
		title: 'Net Loss On Deposit',
		mapDataToValue: (data: any) => data[COL_NAMES.netLossOnDeposit] || EMPTY_NUMBER
	})
];
